/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setCheckUnverifiedAddressesSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getCheckUnverifiedAddressesSFABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

const CheckUnverifiedAddressesABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const checkUnverifiedAddressesSFABTestData = useSelector(getCheckUnverifiedAddressesSFABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Get Campaign - Check Unverified Addresses Checkout',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'CheckUnverifiedAddressesABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Check Unverified Addresses on Checkout Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== checkUnverifiedAddressesSFABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setCheckUnverifiedAddressesSaleForceABTest(data.contentSF));
    }

    return null;
};

CheckUnverifiedAddressesABTest.propTypes = {
    pageType: string.isRequired,
};

export default CheckUnverifiedAddressesABTest;
